import { Actions, ACTIONS_CONFIG } from '@config/actions.config';
import { Subject } from 'rxjs';

export class Constants {
  public destroy$: Subject<boolean> = new Subject<boolean>();
  public displayedActions: Actions = new Actions();
  public displayedColumns: Array<string> = [];
  public labelDelete: any = false;
  public loading = true;
  public error = false;
  public errorText = '';
  public elements = true;
  public filter: Array<any> = [];
  public message = '';
  public actionsList: Array<string> = [
    ACTIONS_CONFIG.add.id,
    ACTIONS_CONFIG.edit.id,
    ACTIONS_CONFIG.delete.id
  ];

  public title = '';
  public action = '';
  public admitted = true;
}
